module.exports = __webpack_public_path__ + "assets/etc.4bc0d025.png";